export interface ProductLineRequest {
  customerId?: number;
  jobsiteId?: number;
  commercialChannelCode?: string;
  countryCode?: string;
}
